export default "__VITE_ASSET__53Kt2kd9__"